module.exports = __webpack_public_path__ + "assets/img/aa-energy.f87115c5.png";